import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IOrganisationForm, OrganisationIndustry } from '@organisations/models/organisations';
import { PhoneNumberControlComponent } from '@shared/components/forms/phone-number-control/phone-number-control.component';
import { SelectControlComponent } from '@shared/components/forms/select-control/select-control.component';
import { StandardControlComponent } from '@shared/components/forms/standard-control/standard-control.component';
import { PageSubtitleComponent } from '@shared/components/sections/page-subtitle/page-subtitle.component';
import { ISelectOption, selectOptionsFromEnum } from '@shared/models/form-controls';

@Component({
	selector: 'app-desktop-organisation-details',
	imports: [
		FormsModule,
		ReactiveFormsModule,
		CommonModule,
		PageSubtitleComponent,
		StandardControlComponent,
		SelectControlComponent,
		PhoneNumberControlComponent,
	],
	templateUrl: './desktop-organisation-details.component.html',
	styleUrl: './desktop-organisation-details.component.scss',
})
export class DesktopOrganisationDetailsComponent {
	@Input() organisationForm: FormGroup<IOrganisationForm>;
	industryOptions: Array<ISelectOption> = selectOptionsFromEnum(OrganisationIndustry);
}
